export default {
    getList: {
        getCloseWorkList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/closure',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminCloseWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}